<!-- 需求提报 -->
<template>
  <div>
    <!-- 搜索 -->
    <div class="container">
      <e-search
        :data="listQuery"
        :field-list="fieldList"
        :list-type-info="listTypeInfo"
        :width="listTypeInfo.width"
        @handleFilter="handleQuery"
        @handleReset="handleReset"
      ></e-search>
    </div>
    <!-- 操作按钮 -->
    <div class="container">
      <eTableList
        :table-data="tableData"
        :table-label="tableLabel"
        :index-show="false"
        :right-span-method="objectSpanMethod"
      >
        <template #index="{ scope:{row} }">
          {{row.index}}
        </template>
        <template #commissionNumber="{scope}">
          <span @click="goCommissionSheet(scope.row)" class="theme">{{scope.row.commissionNumber}}</span>
        </template>
        <template #handle="{ scope }">
          <span v-if="[6,11].includes(scope.row.subStatus)"
                @click="goPath(scope.row, '/ES/businessManagement/enter')"
                class="table-handle-btn">
            修改
          </span>
          <span v-if="[3,4,5,8,9,12,13,14].includes(scope.row.subStatus)"
                @click="goPath(scope.row, '/ES/businessManagement/details')"
                class="table-handle-btn">
            查看
          </span>
          <span v-if="[1,2,7,10].includes(scope.row.subStatus)" class="table-handle-btn"
                @click="goPath(scope.row, '/ES/businessManagement/enter')">
            录入
          </span>
          <span class="table-handle-btn" @click="feedback(scope.row)">
            反馈
          </span>
        </template>
      </eTableList>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :total="total"
          :page-size.sync="listQuery.pageSize"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
    </div>
    <feedback-dialog :visible.sync="visible" :details="info"/>
  </div>
</template>
<script>
import eSearch from '@/modules/projectA/components/common/e-search';
import eTableList from '@/modules/projectA/components/common/e-table-list-merge';
import feedbackDialog from './components/feedbackDialog';
import Api from '@/modules/projectA/api/ESorganization';
import {
  tableLabel,
  fieldList,
  listTypeInfo
} from './components/componentsData.js';
import { dateformate } from '../../../utils/utils';

export default {
  components: { eSearch, eTableList, feedbackDialog },
  data() {
    return {
      tableLabel,
      fieldList,
      listTypeInfo,
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        // 申请单号
        applyCode: '',
        // 委托单号
        commissionNumber: '',
        // 评价状态
        subStatusList: null,
        // 评价编码
        evaluationCode: '',
        // 评价类型
        creditRound: null,
        // 供应商类型
        supplierType: '',
        // 专业
        specialtyId: null,
        // 产品名称
        productName: '',
        // 申请企业
        companyName: '',
        // 资料复审时间
        informationCheckDayCount: null,
        // 现场审查时间
        sceneCheckDayCount: null,
        // 实物测试时间
        entityCheckDayCount: null,
        // 申请日期
        applyTime: null,
        // 完成日期
        finishTime: null
      },
      total: 0,
      cloneListQuery: {},
      tableData: [],
      info: {},
      visible: false
    };
  },
  created() {
    this.cloneListQuery = this.$options.data().listQuery;
    this.getList(this.listQuery);
  },

  methods: {
    /**
     * 点击反馈
     * @param data
     */
    feedback(data) {
      this.info = data;
      this.visible = true;
    },
    /**
     * 跳转产品质量评价工作委托单
     * @param applyId
     */
    goCommissionSheet({ applyId }) {
      const url = this.$router.resolve({
        path: '/ES/enterpriseInfoReview/commissionSheet',
        query: {
          applyId
        }
      }).href;
      window.open(url);
    },
    // 获取列表数据
    async getList(params) {
      this.tableLoading = true;
      await Api.queryEvaluationApplyItemPageList({
        ...params,
        subStatusList: params.subStatusList?.split(','),
        startTime: params.applyTime ? dateformate(params.applyTime[0], 'yyyy-MM-dd') : undefined,
        endTime: params.applyTime ? dateformate(params.applyTime[1], 'yyyy-MM-dd') : undefined,
        applyTime: undefined,
        completeStartTime: params.finishTime ? dateformate(params.finishTime[0], 'yyyy-MM-dd') : undefined,
        completeEndTime: params.finishTime ? dateformate(params.finishTime[1], 'yyyy-MM-dd') : undefined,
        finishTime: undefined,
        creditRound: params.creditRound === 2 ? 0 : params.creditRound
      }).then(res => {
        this.tableLoading = false;
        if (res.code === '200') {
          const { records, total } = res.data;
          const list = [];
          records.forEach((item, i) => {
            // 如果有覆盖关系
            if (item.evaluationApplyItemPriceVOList && item.evaluationApplyItemPriceVOList[0]?.path) {
              // 前面合并的行数
              const length = item.evaluationApplyItemPriceVOList.length;
              // 一个二维数组，存放合并的单元分享
              const arr = [];
              // 按照覆盖等级排序
              const a = item.evaluationApplyItemPriceVOList.sort((a, b) => a.level - b.level);
              for (let i = 0; i < a.length; i++) {
                // 最高级
                arr.push([{ ...a[i], allId: [a[i].id] }]);
                // 复评
                if (a[i].creditRound !== '1') {
                  continue;
                }
                for (let j = i + 1; j < a.length; j++) {
                  // 判断剩下的有没有被当前的合并，（被覆盖并且状态一样并且是初评）
                  if (a[j].pathList.includes(a[i].productId.toString()) && a[j].subStatus === a[i].subStatus && a[j].creditRound === '1') {
                    arr[arr.length - 1].push(a[j]);
                    // 第一个存放所有的单元分项id
                    arr[arr.length - 1][0].allId.push(a[j].id);
                    // 被合并后删除当前项
                    a.splice(j, 1);
                  }
                }
              }
              arr.flat(2).forEach((item2, index) => {
                list.push({
                  ...item,
                  ...item2,
                  evaluationApplyItemPriceVOList: undefined,
                  span: index === 0 ? length : 0,
                  index: i + 1,
                  rightSpan: item2.allId?.length
                });
              });
            } else {
              item.evaluationApplyItemPriceVOList?.forEach((item2, index) => {
                list.push({
                  ...item,
                  ...item2,
                  evaluationApplyItemPriceVOList: undefined,
                  span: index === 0 ? item.evaluationApplyItemPriceVOList.length : 0,
                  rightSpan: 1,
                  index: i + 1
                });
              });
            }
          });
          this.tableData = list;
          this.total = total;
        }
      });
    },
    /**
     * 合并单元格
     * @param row
     * @param columnIndex
     * @returns {{colspan: number, rowspan: *}|{colspan: number, rowspan: number}}
     */
    objectSpanMethod({ row, columnIndex }) {
      // 前四列
      if (columnIndex < 4) {
        if (row.span) {
          return {
            rowspan: row.span,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      } else if (columnIndex > 15) {
        if (row.rightSpan) {
          return {
            rowspan: row.rightSpan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    // 更改页码
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },

    // 更改条数
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getList(this.listQuery);
    },

    // 重置
    handleReset() {
      this.listQuery = { ...this.cloneListQuery };
      this.getList(this.listQuery);
    },

    // 搜索
    handleQuery(val) {
      this.listQuery = { ...val, pageNum: 1 };
      this.getList(this.listQuery);
    },
    /**
     * 跳转产品质量评价工作委托单
     * @param applyId
     */
    goCommissionSheet({ applyId }) {
      const url = this.$router.resolve({
        path: '/ES/enterpriseInfoReview/commissionSheet',
        query: {
          applyId
        }
      }).href;
      window.open(url);
    },
    goPath(row, path) {
      const { applyId, subStatus, evaluationItemId, id, supplierType, creditRound, isStructured, evaluateItemPriceId, allId } = row;
      this.$router.push({
        path,
        query: {
          applyId,
          subStatus,
          evaluationItemId,
          id,
          creditRound,
          supplierType,
          isStructured,
          evaluateItemPriceId,
          allId: allId || [id]
        }
      });
    }
  },
  mounted() {
  }
};
</script>
<style lang="scss" scoped>
  @import '@/assets/css/theme.scss';

  .theme {
    color: $main-col;
    cursor: pointer;
  }

  .table-handle-btn + .table-handle-btn {
    margin-left: 10px;
  }
</style>
